<ng-container *ngIf="externalGptConfig$ | async as config; else loadingTemplate">
  <div
    mat-dialog-title
    appDraggableDialog
    draggableKey="agentforce"
    appResizableDialog
    dialogClass="agentforce"
    [resizableKey]="type"
    resizableTargetClass="agentforce">
    <div class="dialog-title">
      <span>{{ modalTitle | translate: getTranslateParams(config.enabled) }}</span>
      <q9-icon-button
        icon="copy"
        matTooltipPosition="above"
        [matTooltip]="'ASIDE_R.AGENTFORCE_COPY' | translate"
        (click)="copyLinkToClipboard()"></q9-icon-button>
    </div>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <mat-dialog-content class="agentforce-content">
    <div class="pre-wrap" [innerHTML]="data.instructions || data.testUtterances | textToHtml"></div>
  </mat-dialog-content>
</ng-container>

<ng-template #loadingTemplate>
  <q9-content-loader [isLoading]="true"></q9-content-loader>
</ng-template>
